import { Root } from "./Root"
import { Summary } from "./Summary"
import { Details } from "./Details"

const Accordion = {
    Summary,
    Root,
    Details
}

export {Accordion}